"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const state_1 = __importDefault(require("../../state"));
const drawRectangle = (color, opacity, x, y, width, height, zIndex) => {
    const rectangle = new pixi_js_1.Graphics;
    rectangle.beginFill(Number(`0x${color.substring(1)}`));
    rectangle.lineStyle(0, Number(`0x${color.substring(1)}`));
    rectangle.drawRect(x, y, width, height);
    rectangle.alpha = opacity;
    rectangle.zIndex = zIndex;
    state_1.default.app.stage.addChild(rectangle);
};
exports.default = drawRectangle;
